import { render, staticRenderFns } from "./CogneetivCodex.vue?vue&type=template&id=35fd0031&"
import script from "./CogneetivCodex.vue?vue&type=script&lang=js&"
export * from "./CogneetivCodex.vue?vue&type=script&lang=js&"
import style0 from "./CogneetivCodex.vue?vue&type=style&index=0&id=35fd0031&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports